import { ACCENT_BRAND_ID, BRAND_ID } from '@app/core/config/brand.constants';

/** Accent keeps the Twilio chat (`chat-twilio`); every other brand opens the omnichannel 1-on-1 chat modal. */
export function usesTwilioChat(): boolean {
  return BRAND_ID.toLowerCase() === ACCENT_BRAND_ID.toLowerCase();
}
